"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyResultLayout = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const SurveyResultItem_1 = __importDefault(require("./SurveyResultItem"));
const constant_1 = require("./constant");
// SurveyLayout 컴포넌트
exports.SurveyResultLayout = react_1.default.memo(({ surveyData, setSurveyData, isRegist, isSubmit, frequencies, }) => {
    const [defaultData, setDefaultData] = react_1.default.useState(surveyData);
    const [list, setList] = react_1.default.useState(defaultData);
    // 데이터 업데이트 함수
    const updateData = ({ id, data }) => {
        if (list) {
            setList(list.map(item => (item.id === id ? { ...item, ...data } : { ...item })));
        }
    };
    const addSurveyItem = () => {
        // surveyData 배열의 길이 확인
        const length = list.length;
        // id 생성: -length를 사용하여 고유한 id 생성
        const newItemId = `survey-${(0, moment_1.default)().unix()}-${length}`;
        // 새로운 설문 항목 객체 생성
        const newItem = {
            id: newItemId,
            title: '',
            type: constant_1.SURVEY_TYPE.OBJECTIVE,
            data: [],
        };
        // 기존 surveyData 배열에 새로운 항목 추가
        const updatedList = [...list, newItem];
        // 상태 업데이트
        setList(updatedList);
        setDefaultData(updatedList);
    };
    const deleteSurveyItem = ({ id }) => {
        if (list && list.length > 1) {
            const newList = list.filter(item => item.id !== id);
            setList(newList);
            setDefaultData(newList);
        }
        else {
            alert('최소 1개 이상의 설문 항목이 필요합니다.');
        }
    };
    (0, react_1.useEffect)(() => {
        if (surveyData.length == 0)
            return;
        if (defaultData.length > 0)
            return;
        if (defaultData == surveyData)
            return;
        setDefaultData(surveyData);
    }, [surveyData]);
    (0, react_1.useEffect)(() => {
        if (defaultData.length == 0)
            return;
        if (list.length > 0)
            return;
        if (list == defaultData)
            return;
        setList(defaultData);
    }, [defaultData]);
    // 데이터 변경 시 콜백 함수
    react_1.default.useEffect(() => {
        if (list.length == 0)
            return;
        setSurveyData && setSurveyData(list);
    }, [list]);
    react_1.default.useEffect(() => {
        setDefaultData(surveyData);
    }, [surveyData]);
    react_1.default.useEffect(() => {
        APP.eventManager.subscribe('UPDATE_SURVEY_ITEM', updateData);
        return () => {
            APP.eventManager.unsubscribe('UPDATE_SURVEY_ITEM', updateData);
        };
    }, [list]);
    react_1.default.useEffect(() => {
        if (!isRegist)
            return;
        APP.eventManager.subscribe('ADD_SURVEY_ITEM', addSurveyItem);
        APP.eventManager.subscribe('DELETE_SURVEY_ITEM', deleteSurveyItem);
        return () => {
            APP.eventManager.unsubscribe('ADD_SURVEY_ITEM', addSurveyItem);
            APP.eventManager.unsubscribe('DELETE_SURVEY_ITEM', deleteSurveyItem);
        };
    }, [list]);
    const component = react_1.default.useMemo(() => {
        return (react_1.default.createElement(react_1.default.Fragment, null, defaultData.length > 0 &&
            defaultData.map((item, index) => (react_1.default.createElement(SurveyResultItem_1.default, { key: index, index: index, item: item, isSubmit: isSubmit, isRegist: isRegist, frequencies: frequencies })))));
    }, [defaultData, frequencies]);
    return react_1.default.createElement(react_1.default.Fragment, null, component);
});
